import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Team from './Team';
import './about.css';

function AboutUs() {
  return (
    <section className="about-page">
      <Container className="about-wrap">
        <div className="about-hero">
          <div className="about-hero-left">
            <div className="about-pill">📝ABOUT DTE</div>
            <h1 className="about-title">Giving Solutions To Your Works</h1>
            <p className="about-subtitle">
              Divine-Tech Engineering is a Malawian-based engineering firm specializing in water systems installation,
              mechanical works, fabrication, and maintenance services. We provide practical, field-oriented solutions aimed
              at improving water access and infrastructure reliability in both rural and urban communities.
            </p>

            <div className="about-cta-row">
              <Link className="about-cta" to="/contact">
                Talk to us
              </Link>
              <Link className="about-cta about-cta-secondary" to="/quote">
                Get a Quote
              </Link>
            </div>
          </div>

          <div className="about-hero-right">
            <img
              className="about-hero-image"
              src="/images/39.jpg"
              alt="Divine-Tech Engineering field work"
            />
          </div>
        </div>

        <Row className="about-grid">
          <Col lg={4} md={6} className="about-col">
            <div className="about-card">
              <div className="about-card-title">What We Do</div>
              <ul className="about-list">
                <li>Water supply system installation (boreholes, pipelines, storage)</li>
                <li>Pump installation, maintenance & repair (submersible & surface)</li>
                <li>Pipeline installation & rehabilitation</li>
                <li>Water meter installation & calibration</li>
                <li>Fabrication & welding works (meter boxes, steel structures, tanks)</li>
                <li>Solar-powered water system installation</li>
              </ul>
            </div>
          </Col>

          <Col lg={4} md={6} className="about-col">
            <div className="about-card">
              <div className="about-card-title">Mission & Vision</div>
              <div className="about-copy">
                <p>
                  <span className="about-strong">Mission:</span> To provide reliable, innovative, and sustainable engineering
                  solutions in water systems and mechanical services that improve community livelihoods and infrastructure
                  efficiency.
                </p>
                <p>
                  <span className="about-strong">Vision:</span> To become a leading engineering solutions provider in Malawi and
                  beyond, known for quality workmanship, innovation, and impactful service delivery.
                </p>
                <p>
                  <span className="about-strong">Motto:</span> “Engineering Solutions That Flow.”
                </p>
              </div>
            </div>
          </Col>

          <Col lg={4} md={6} className="about-col">
            <div className="about-card">
              <div className="about-card-title">Core Values</div>
              <ul className="about-list">
                <li>Quality workmanship</li>
                <li>Reliability</li>
                <li>Innovation</li>
                <li>Integrity</li>
                <li>Customer satisfaction</li>
                <li>Safety first</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>

      <Team embedded />
    </section>
  );
}

export default AboutUs;
